import { GlAccountRuleRole, GlAccountRuleScope } from './gl-account-rule';

/** The rule drawer's form. An empty string in a dimension means "any". */
export interface GlAccountRuleFormModel {
  scope: GlAccountRuleScope;
  role: GlAccountRuleRole;
  costCenterCode: string;
  conceptCode: string;
  inventoryTypeReference: string;
  glAccountReference: string | null;
}

/** Translation key per field, for the invalid-field toast. */
export const glAccountRuleFieldLabels: Record<keyof GlAccountRuleFormModel, string> = {
  scope: 'GlAccountRule_Details_Form_Field_Scope',
  role: 'GlAccountRule_Details_Form_Field_Role',
  costCenterCode: 'GlAccountRule_Details_Form_Field_CostCenter',
  conceptCode: 'GlAccountRule_Details_Form_Field_Concept',
  inventoryTypeReference: 'GlAccountRule_Details_Form_Field_InventoryType',
  glAccountReference: 'GlAccountRule_Details_Form_Field_Account',
};
